import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import {
  Environment,
  ModelStrStr,
  PersoneGruppi,
  IPersoneGruppiPersonaModel,
  IPersoneGruppoTableModel,
  ITicketsTipiStatiGruppi,
} from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class PersoneGruppiService extends CrudGenericsService<PersoneGruppi, number> {
  private base: string;
  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/PersoneGruppi`);
    this.base = `${env.apiUrl}/api/PersoneGruppi/`;
  }
  // tabella
  Get_PersoneGruppoTableModel(): Observable<IPersoneGruppoTableModel[]> {
    const url = this.base + 'Get_PersoneGruppoTableModel';
    return this.http.get<IPersoneGruppoTableModel[]>(`${url}`);
  }
  Get_All(): Observable<PersoneGruppi[]> {
    const url = this.base + 'Get4All';
    return this.http.get<PersoneGruppi[]>(`${url}`);
  }

  Save_Gruppi(dati: ITicketsTipiStatiGruppi) {
    const url = this.base + 'Save_Gruppi';
    return this._http.post<ITicketsTipiStatiGruppi>(url, dati);
  }

  Delete_Gruppi(dati: ModelStrStr) {
    const url = this.base + 'Delete_Gruppi';
    return this._http.post<ModelStrStr>(url, dati);
  }
  // per il rendering dei gruppi-persone
  GetPersoneGruppiPersonaModel_All0OrByGruppoOrByPersona(
    id_gruppo: number = 0,
    id_persona: number = 0
  ): Observable<IPersoneGruppiPersonaModel> {
    const url =
      this.base + 'GetPersoneGruppiPersonaModel_All0OrByGruppoOrByPersona?gruppo=' + id_gruppo + '&persona=' + id_persona;
    return this.http.get<IPersoneGruppiPersonaModel>(`${url}`);
  }
}
